export enum PhoneSettingProvider{
    TWILIO = 'TWILIO',
    TELNYX = 'TELNYX',
    SIP_TRUNK = 'SIP_TRUNK'
}